import { Component, Output, EventEmitter, Input } from '@angular/core';
import { GetEmpty } from 'src/app/classes/Empties';
import { Utils } from 'src/app/classes/Utils';
import {PaymentInfo} from 'src/app/models/models';
import { Bank_Movement, Bank_Account, Currency } from 'src/app/models/RestModels';
import {BaseComponent} from 'src/app/pages/base/base.component';

@Component({
	selector: 'app-add-pos-bill',
	templateUrl: './add-pos-bill.component.html',
	styleUrls: ['./add-pos-bill.component.css']
})
export class AddPosBillComponent extends BaseComponent
{
	total:number | null = null;
	note:string	= '';
	receipt_attachment_id:number | null = null;
	imprimir_recibo:boolean = true;
	tag:string = '';
	bank_account_list:Bank_Account[] = [];
	dest_bank_account_id:number | null = null;
	currency_list:Currency[] = [];
	currency_id:string = 'MXN';
	@Input() store_id: number | null = null;
	@Output() expenseAdded = new EventEmitter<PaymentInfo | null>();

	ngOnInit(): void
	{
		this.total = null;
		this.note	= '';
		this.dest_bank_account_id = null;

		this.subs.sink = this.rest.bank_account.search({})
			.subscribe((response)=>
			{
				this.bank_account_list = response.data;
			},(error)=>this.showError(error));

		this.subs.sink = this.rest.currency.search({ limit: 999999 })
			.subscribe((response)=>
			{
				this.currency_list = response.data;
			},(error)=>this.showError(error));
	}

	save(evt:Event)
	{
		evt.preventDefault();
		this.is_loading = true;
		this.saveExpense();
	}

	saveExpense()
	{
		let bank_movement:Bank_Movement =  GetEmpty.bank_movement();

		let payment:Partial<PaymentInfo> = {
			payment:{
				change_amount: 0,
				concept: this.note,
				currency_id: this.currency_id,
				facturado: 'NO',
				payment_amount: this.total,
				received_amount: this.total,
				sat_pdf_attachment_id: null,
				sat_factura_id: null,
				sat_xml_attachment_id: null,
				store_id: this.store_id,
				sync_id: this.rest.getSyncId(),
				tag: this.tag,
				type:'expense',
			},
			movements:
			[{
				bank_movement:
				{
					...bank_movement,
					type: 'expense',
					transaction_type: 'CASH',
					status			: 'ACTIVE',
					bank_account_id	: this.dest_bank_account_id,
					origin_bank_name: null,
					total: this.total,
					receipt_attachment_id:this.receipt_attachment_id,
					amount_received: this.total,
					exchange_rate: 1,
					currency_id: this.currency_id
				},
				bank_movement_orders:[],
				bank_movement_bills:[{
					bill:{
						total: this.total,
						note: this.note,
						accepted_status:'ACCEPTED',
						paid_status:'PAID',
						currency_id:this.currency_id,
						receipt_attachment_id:this.receipt_attachment_id,
						name: this.tag,
						status:'ACTIVE'
					},
					bank_movement_bill:
					{
						amount:this.total,
						currency_amount: this.total,
						exchange_rate: 1,
						currency_id:this.currency_id,
						status:'ACTIVE',
					}
				}]
			}]
		};

		this.subs.sink = this.rest.payment_info
		.create(payment)
		.subscribe((response)=>
		{
			this.expenseAdded.emit(response);
			if( this.imprimir_recibo )
			{
				Utils.openPrintTab('/#/print-payment-expense/'+response.payment.id+'/print=1');
			}

			this.resetForm();
			setTimeout(()=>{this.imprimir_recibo = true },300);
			this.is_loading = false;
		},(error)=>this.showError(error));
	}

	resetForm()
	{
		this.total = null;
		this.note	= '';
		this.receipt_attachment_id = null;
		this.tag = '';
		this.dest_bank_account_id = null;
		this.currency_id = 'MXN';
	}

	cancel()
	{
		this.expenseAdded.emit(null);
	}

	imprimirChanged(evt:Event)
	{
		let input = evt.target as HTMLInputElement;
		this.imprimir_recibo = input.checked;
	}
}
